import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
const config = {
    apiKey: "AIzaSyCFFZ_By2J_qbWNhT66O1RpLwbicjTABp0",
    authDomain: "timeline-85a62.firebaseapp.com",
    databaseURL: "https://timeline-85a62.firebaseio.com",
    projectId: "timeline-85a62",
    storageBucket: "timeline-85a62.appspot.com",
    messagingSenderId: "104605412881",
    appId: "1:104605412881:web:2f9f3dce4193391fb28bb0",
    measurementId: "G-ER6DYW985H"
};

firebase.initializeApp(config);
export const db = firebase.firestore();
export const firestore = firebase.firestore;